import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-audit-logs-revision',
  templateUrl: './audit-logs-revision.component.html',
  styleUrls: ['./audit-logs-revision.component.scss']
})
export class AuditLogsRevisionComponent implements OnInit {
@Input() public Content:any
  subGetAuditLogRevisionList: SubscriptionLike;
  rowData: any = [];
  columnDefs: any;
  selectedRow: any;
  gridApi: GridApi;
  gridColumnApi: any
  gridOptions: any;
  rowSelection;
  public content: any;
  searchdata: any;
  RevisionNo: any = []
  auditLogSearch = new IEGAuditLogSearch();

  action: Subject<any> = new Subject();

  constructor(
    public modalRef: NgbActiveModal,
    public apiService: ApidataRequestService,
    private commonService: CommonService) { }

  ngOnDestroy(): void {
    if (this.subGetAuditLogRevisionList)
      this.subGetAuditLogRevisionList.unsubscribe();
  }

  ngOnInit(): void {
    this.gridHeaderandActionSettings();
    this.rowData = [];
    this.searchdata = this.Content.content.search_data;
    var ArrayRevisionNum = this.Content.content.RevisionNo
    this.RevisionNo = ArrayRevisionNum.filter((c, index) => {
      return ArrayRevisionNum.indexOf(c) === index;
    });
     
    this.auditLogSearch = new IEGAuditLogSearch();
    this.auditLogSearch.ApplicationId = this.searchdata.ApplicationId;
    this.auditLogSearch.ModuleId = this.searchdata.ModuleId;
    this.auditLogSearch.GrantType = this.searchdata.GrantType;
    this.auditLogSearch.ScreenName = this.searchdata.ScreenName;
    this.auditLogSearch.UserName = this.searchdata.UserName;
    this.auditLogSearch.StartDate = this.searchdata.StartDate;
    this.auditLogSearch.EndDate = this.searchdata.EndDate;
    this.auditLogSearch.VersionID =this.Content.content.ID
    this.auditLogSearch.cDetails = "R";
    this.auditLogSearch.cComp = "v";
    this.subGetAuditLogRevisionList = this.apiService.getDataPost("api/IEGAuditActivityLogs/GetIEGAuditLogDataForScreenSearch", this.auditLogSearch).subscribe(result => {
      if (result.Status && result.Data.length > 0) {
        this.rowData = result.Data;
      } else {
        this.rowData = [];
      }
    });
  }

  gridHeaderandActionSettings() {
    this.gridOptions = {
      pagination: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      onFirstDataRendered: (params) => {
        params.api.forEachNode((node) =>
          this.RevisionNo.forEach((r) => {
            if (node.data.Revision_num == r) {
              node.setSelected(true)
            }
          }
          ));
      }
    }
    this.columnDefs = [
      { headerName: "", field: 'change_description', width: 5, sortable: false, tooltipField: "ChangeDescription", headerCheckboxSelection: true, checkboxSelection: true },
      { headerName: "Revision", headerTooltip: "Revision", field: 'Revision_num', width: 30, sortable: false, tooltipField: "Revision_num" },
      { headerName: "Changed Date and Time", headerTooltip: "Changed Date and Time", field: 'Last_modified_date', width: 80, sortable: false, tooltipField: "Last_modified_date" },
      { headerName: "Username", headerTooltip: "Username", field: 'Username', width: 100, sortable: false, tooltipField: "Username" }
    ];
    this.rowSelection = 'multiple';
  }


  onSetGridApi(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    setTimeout(() => {
      if (true) {
        params.api.forEachNode((node: any) => {
          if (this.RevisionNo) {
            this.RevisionNo.forEach(element => {
              if (node.data.Revision_num === element) {
                node.setSelected(true);
              }
            });
          }
          else {

          }
        });
      }
    }, 500);
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnClickOk() {
     
    this.selectedRow = this.gridApi.getSelectedRows();
    if(this.selectedRow.length>0)
    {
   // this.action.next(this.selectedRow);
    this.modalRef.close(this.selectedRow);
    }
    else
    {
      var err: any = [];
      err.push("Please select at least one Revision");
      this.commonService.ValidationBanner(err);
    }
  }

  cancelmodal() {
    this.modalRef.dismiss();
  }

}

export class IEGAuditLogSearch {
  ModuleId?: string;
  ApplicationId?: string;
  ScreenName?: string;
  UserName?: string;
  StartDate?: string;
  EndDate?: string;
  OrgID?: string;
  VersionID?:string;
  cDetails?: string;
  cComp?: string;
  GrantType?: string;
}
